import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.29.0/Seq.js";
import { Image, Button } from "@fluentui/react-components";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { Browser_Types_File__File_ReadAsByteArray } from "./fable_modules/Fable.Remoting.Client.8.0.0/Extensions.fs.js";
import { S3 } from "./ApiClient.jsx";
import { S3UploadFile } from "./Shared/SharedModels.jsx";
import { defaultOf } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { Union } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { option_type, list_type, tuple_type, string_type, union_type, int32_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { tail, head, isEmpty, empty } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { Route_$007CInt$007C_$007C, Route_$007CQuery$007C_$007C } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function S3UploadTester() {
    const patternInput = reactApi.useState(undefined);
    const patternInput_1 = reactApi.useState(undefined);
    const children = toList(delay(() => append(singleton(createElement("input", {
        type: "file",
        onChange: (ev) => {
            const files = ev.target.files;
            if (!(files == null) && (files.length > 0)) {
                patternInput[1](files.item(0));
            }
        },
    })), delay(() => {
        let el;
        const matchValue = patternInput[0];
        if (matchValue != null) {
            const f_1 = matchValue;
            return append(singleton((el = Button, createElement(el, {
                children: "Upload",
                onClick: (_arg) => {
                    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (startAsPromise(Browser_Types_File__File_ReadAsByteArray(f_1)).then((_arg_1) => {
                        let MimeType;
                        const pr = startAsPromise(S3.UploadFile((MimeType = f_1.type, new S3UploadFile(f_1.name, MimeType, _arg_1))));
                        void (pr.then((res) => {
                            if (res.tag === 0) {
                                patternInput_1[1](res.fields[0]);
                            }
                        }));
                        return Promise.resolve();
                    }))));
                    void pr_1;
                },
            }))), delay(() => {
                let el_2;
                const matchValue_1 = patternInput_1[0];
                return (matchValue_1 != null) ? singleton((el_2 = Image, createElement(el_2, {
                    src: matchValue_1,
                }))) : singleton(defaultOf());
            }));
        }
        else {
            return singleton(defaultOf());
        }
    }))));
    return createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export class CoursePage extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["View"];
    }
}

export function CoursePage_$reflection() {
    return union_type("Routes.CoursePage", [], CoursePage, () => [[["Item", int32_type]]]);
}

export class EventPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["View", "List"];
    }
}

export function EventPage_$reflection() {
    return union_type("Routes.EventPage", [], EventPage, () => [[["Item", int32_type]], [["Item", list_type(tuple_type(string_type, string_type))]]]);
}

export class AdminPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Workplaces", "Regions", "Titles", "ApproveUsers", "Reports", "Rules"];
    }
}

export function AdminPage_$reflection() {
    return union_type("Routes.AdminPage", [], AdminPage, () => [[], [], [], [], [], []]);
}

export class TrackPage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["List", "View", "Builder", "CourseTemplates"];
    }
}

export function TrackPage_$reflection() {
    return union_type("Routes.TrackPage", [], TrackPage, () => [[], [["Item", int32_type]], [["Item", option_type(int32_type)]], []]);
}

export class Page extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Calendar", "S3Test", "Course", "Event", "Track", "UserProfile", "UserFremdrift", "UserHistory", "Admin", "Documentation", "NotFound"];
    }
}

export function Page_$reflection() {
    return union_type("Routes.Page", [], Page, () => [[], [], [], [["Item", CoursePage_$reflection()]], [["Item", EventPage_$reflection()]], [["Item", TrackPage_$reflection()]], [["Item", int32_type]], [["Item", int32_type]], [["Item", int32_type]], [["Item", AdminPage_$reflection()]], [], []]);
}

function eventRouter(url) {
    let matchResult, eventId;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (isEmpty(tail(url))) {
                matchResult = 1;
                eventId = activePatternResult;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(4, [new EventPage(1, [empty()])]);
        case 1:
            return new Page(4, [new EventPage(0, [eventId])]);
        default: {
            let matchResult_1, parameters;
            if (!isEmpty(url)) {
                const activePatternResult_1 = Route_$007CQuery$007C_$007C(head(url));
                if (activePatternResult_1 != null) {
                    if (isEmpty(tail(url))) {
                        matchResult_1 = 0;
                        parameters = activePatternResult_1;
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(4, [new EventPage(1, [parameters])]);
                default:
                    return new Page(11, []);
            }
        }
    }
}

function courseRouter(url) {
    let matchResult, courseId;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (isEmpty(tail(url))) {
                matchResult = 0;
                courseId = activePatternResult;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Page(3, [new CoursePage(courseId)]);
        default:
            return new Page(11, []);
    }
}

function trackRouter(url) {
    let matchResult, id;
    if (!isEmpty(url)) {
        const activePatternResult = Route_$007CInt$007C_$007C(head(url));
        if (activePatternResult != null) {
            if (isEmpty(tail(url))) {
                matchResult = 1;
                id = activePatternResult;
            }
            else {
                matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(5, [new TrackPage(0, [])]);
        case 1:
            return new Page(5, [new TrackPage(1, [id])]);
        default: {
            let matchResult_1, id_1;
            if (!isEmpty(url)) {
                if (head(url) === "bygger") {
                    if (!isEmpty(tail(url))) {
                        const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(url)));
                        if (activePatternResult_1 != null) {
                            if (isEmpty(tail(tail(url)))) {
                                matchResult_1 = 1;
                                id_1 = activePatternResult_1;
                            }
                            else {
                                matchResult_1 = 2;
                            }
                        }
                        else {
                            matchResult_1 = 2;
                        }
                    }
                    else {
                        matchResult_1 = 0;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(5, [new TrackPage(2, [undefined])]);
                case 1:
                    return new Page(5, [new TrackPage(2, [id_1])]);
                default: {
                    let matchResult_2;
                    if (!isEmpty(url)) {
                        if (head(url) === "bygger") {
                            if (!isEmpty(tail(url))) {
                                if (head(tail(url)) === "kurs") {
                                    if (isEmpty(tail(tail(url)))) {
                                        matchResult_2 = 0;
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Page(5, [new TrackPage(3, [])]);
                        default:
                            return new Page(11, []);
                    }
                }
            }
        }
    }
}

function adminRouter(url) {
    let matchResult;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "bruker": {
                if (!isEmpty(tail(url))) {
                    if (head(tail(url)) === "godkjenn") {
                        if (isEmpty(tail(tail(url)))) {
                            matchResult = 0;
                        }
                        else {
                            matchResult = 6;
                        }
                    }
                    else {
                        matchResult = 6;
                    }
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "arbeidsplasser": {
                if (isEmpty(tail(url))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "regioner": {
                if (isEmpty(tail(url))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "titler": {
                if (isEmpty(tail(url))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "rapporter": {
                if (isEmpty(tail(url))) {
                    matchResult = 4;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            case "regler": {
                if (isEmpty(tail(url))) {
                    matchResult = 5;
                }
                else {
                    matchResult = 6;
                }
                break;
            }
            default:
                matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0:
            return new Page(9, [new AdminPage(3, [])]);
        case 1:
            return new Page(9, [new AdminPage(0, [])]);
        case 2:
            return new Page(9, [new AdminPage(1, [])]);
        case 3:
            return new Page(9, [new AdminPage(2, [])]);
        case 4:
            return new Page(9, [new AdminPage(4, [])]);
        case 5:
            return new Page(9, [new AdminPage(5, [])]);
        default:
            return new Page(11, []);
    }
}

export function pageFromUrl(url) {
    let matchResult, rest, rest_1, uId;
    if (!isEmpty(url)) {
        switch (head(url)) {
            case "kalender": {
                if (isEmpty(tail(url))) {
                    matchResult = 1;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "s3": {
                if (isEmpty(tail(url))) {
                    matchResult = 2;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "dokumentasjon": {
                if (isEmpty(tail(url))) {
                    matchResult = 3;
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            case "kurs": {
                matchResult = 4;
                rest = tail(url);
                break;
            }
            case "arrangement": {
                matchResult = 5;
                rest_1 = tail(url);
                break;
            }
            case "bruker": {
                if (!isEmpty(tail(url))) {
                    const activePatternResult = Route_$007CInt$007C_$007C(head(tail(url)));
                    if (activePatternResult != null) {
                        if (isEmpty(tail(tail(url)))) {
                            matchResult = 6;
                            uId = activePatternResult;
                        }
                        else {
                            matchResult = 7;
                        }
                    }
                    else {
                        matchResult = 7;
                    }
                }
                else {
                    matchResult = 7;
                }
                break;
            }
            default:
                matchResult = 7;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return new Page(0, []);
        case 1:
            return new Page(1, []);
        case 2:
            return new Page(2, []);
        case 3:
            return new Page(10, []);
        case 4:
            return courseRouter(rest);
        case 5:
            return eventRouter(rest_1);
        case 6:
            return new Page(6, [uId]);
        default: {
            let matchResult_1, uId_1;
            if (!isEmpty(url)) {
                if (head(url) === "bruker") {
                    if (!isEmpty(tail(url))) {
                        const activePatternResult_1 = Route_$007CInt$007C_$007C(head(tail(url)));
                        if (activePatternResult_1 != null) {
                            if (!isEmpty(tail(tail(url)))) {
                                if (head(tail(tail(url))) === "fremdrift") {
                                    if (isEmpty(tail(tail(tail(url))))) {
                                        matchResult_1 = 0;
                                        uId_1 = activePatternResult_1;
                                    }
                                    else {
                                        matchResult_1 = 1;
                                    }
                                }
                                else {
                                    matchResult_1 = 1;
                                }
                            }
                            else {
                                matchResult_1 = 1;
                            }
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return new Page(7, [uId_1]);
                default: {
                    let matchResult_2, uId_2;
                    if (!isEmpty(url)) {
                        if (head(url) === "bruker") {
                            if (!isEmpty(tail(url))) {
                                const activePatternResult_2 = Route_$007CInt$007C_$007C(head(tail(url)));
                                if (activePatternResult_2 != null) {
                                    if (!isEmpty(tail(tail(url)))) {
                                        if (head(tail(tail(url))) === "historikk") {
                                            if (isEmpty(tail(tail(tail(url))))) {
                                                matchResult_2 = 0;
                                                uId_2 = activePatternResult_2;
                                            }
                                            else {
                                                matchResult_2 = 1;
                                            }
                                        }
                                        else {
                                            matchResult_2 = 1;
                                        }
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                            }
                            else {
                                matchResult_2 = 1;
                            }
                        }
                        else {
                            matchResult_2 = 1;
                        }
                    }
                    else {
                        matchResult_2 = 1;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return new Page(8, [uId_2]);
                        default: {
                            let matchResult_3, rest_2, rest_3;
                            if (!isEmpty(url)) {
                                switch (head(url)) {
                                    case "laeringslop": {
                                        matchResult_3 = 0;
                                        rest_2 = tail(url);
                                        break;
                                    }
                                    case "admin": {
                                        matchResult_3 = 1;
                                        rest_3 = tail(url);
                                        break;
                                    }
                                    default:
                                        matchResult_3 = 2;
                                }
                            }
                            else {
                                matchResult_3 = 2;
                            }
                            switch (matchResult_3) {
                                case 0:
                                    return trackRouter(rest_2);
                                case 1:
                                    return adminRouter(rest_3);
                                default:
                                    return new Page(11, []);
                            }
                        }
                    }
                }
            }
        }
    }
}

//# sourceMappingURL=Routes.jsx.map
